export function extractFileNameFromContentDisposition(contentDisposition = '') {
  const regex = /filename=([^;]*)/;
  const matches = contentDisposition.match(regex);

  return matches?.[1] || '';
}
